export default "__VITE_ASSET__Csi_V4Uv__"